import { useGetMe } from '@/hooks/useGetMe';
import { InfoMessage } from '@/webkit/InfoMessage';
import { useTranslation } from 'react-i18next';

export const OperationUnavailableMessage = ({ className  }) => {
  const {
    canAddCash,
    canWithdraw,
    hasAddCashRestriction,
    hasWithdrawRestriction,
  } = useGetMe();
  const { t } = useTranslation();

  if (canAddCash && canWithdraw) return null;

  let title = t('funds:operation_unavailable.title');
  let desc = null;

  if (hasAddCashRestriction) {
    desc = t('funds:operation_unavailable.add_cash_unavailable');
  }

  if (hasWithdrawRestriction) {
    desc = t('funds:operation_unavailable.withdraw_unavailable');
  }

  if (hasAddCashRestriction && hasWithdrawRestriction) {
    desc = t('funds:operation_unavailable.both_unavailable');
  }

  if (!desc) return null;

  return (
    <InfoMessage
      type="warning"
      title={title}
      desc={desc}
      className={className}
    />
  );
};
